<template>
  <a-layout>
    <router-view></router-view>
  </a-layout>
</template>

<script>
export default {
  name: "GuestLayout",
};
</script>

<style scoped lang="scss">
.ant-layout {
  height: 100vh;
}
</style>
